import { RefundBill } from '@repo/components';
import styled from 'styled-components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useState } from 'react';

type Props = {
  billList: any[];
  onClick?: (info?: any) => void;
  type: 'store' | 'medical' | 'hotel';
  nation?: string;
};

export const RefundBillList = ({
  billList,
  onClick = () => {},
  type,
  nation = '',
}: Props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const settings = {
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: '16px',
    centerMode: true,
    infinite: false,
    arrows: false,
    appendDots: (dots: any) => <DotsList>{dots}</DotsList>,
    dotsClass: 'dots_custom',
  };

  const onOpenBill = (index: number) => {
    onClick(index);
  };

  const changeData = (data: any) => {
    switch (type) {
      case 'store':
        return {
          storeName: data.franchiseeName,
          price: Number(data.totalAmount),
          refund: Number(data.totalRefund),
          refundStatus: data.refundStatus,
          serialNumber: data.purchaseSn,
          saleDate: data.saleDate,
          refundDate: data.refundDate,
        };
      case 'medical':
        return {
          storeName: data.hospitalName,
          price: Number(data.totalAmount),
          refund: Number(data.refundAmount),
          refundStatus: data.refundStatus,
          serialNumber: data.serialNumber,
          saleDate: data.supplyDate,
          refundDate: data.refundDate,
        };
      case 'hotel':
        return {
          storeName: data.signboard,
          price: Number(data.totalAmount),
          refund: Number(data.refundAmount),
          refundStatus: data.refundStatus,
          serialNumber: data.serialNumber,
          saleDate: data.registerDate,
          refundDate: data.refundDate,
        };
    }
  };

  return (
    <StyledSlider
      {...settings}
      customPaging={(i: any) => <Dot $isActive={i === currentIndex} />}
      afterChange={(v) => setCurrentIndex(v)}
    >
      {billList.map(({ refundIndex, ...props }, index) => (
        <RefundBill
          key={refundIndex}
          nation={nation}
          onClick={() => onOpenBill(type === 'store' ? index : refundIndex)}
          {...changeData(props)}
          isMultiple={billList.length > 1}
        />
      ))}
    </StyledSlider>
  );
};

const StyledSlider = styled(Slider)`
  .dots_custom {
    display: inline-block;
    vertical-align: middle;
    margin: auto 0;
    padding: 0;
  }

  .dots_custom li {
    list-style: none;
    cursor: pointer;
    display: inline-block;
    margin: 0;
    padding: 0;
  }

  .dots_custom li button {
    border: none;
    background: #cbccce;
    color: transparent;
    cursor: pointer;
    display: block;
    height: 8px;
    width: 8px;
    border-radius: 100%;
    padding: 0;
  }

  .dots_custom li.slick-active button {
    background-color: #246cf6;
  }
`;

const DotsList = styled.ul`
  width: 100%;
  display: flex !important;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const Dot = styled.div<{ $isActive: boolean }>`
  width: ${({ $isActive }) => ($isActive ? '24px' : '8px')};
  height: 8px;
  background-color: ${(props) => (props.$isActive ? '#246cf6' : '#cbccce')};
  border-radius: 120px;
`;
